module.exports = __webpack_public_path__ + "static/media/crossIcon.d3fe5779.svg";